import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.PEDIDO.SET_ID_ORGAO_FILTRO_COLLAPSE](state, idOrgao) {
		state.collapse.idOrgao = idOrgao
	},
}
